"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _react = _interop_require_default(require("react"));
var _Box = require("../../layouts/Box/index");
var _typography = require("../../typography/index");
var _react1 = require("@chakra-ui/react");
var _AutocompleteMultiSelect = require("./AutocompleteMultiSelect");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var AutocompleteMultiSelectList = function(_param) {
    var noResultsContent = _param.noResultsContent, renderItem = _param.renderItem, rest = _object_without_properties(_param, [
        "noResultsContent",
        "renderItem"
    ]);
    var _useAutocompleteMultiSelectContext = (0, _AutocompleteMultiSelect.useAutocompleteMultiSelectContext)(), isOpen = _useAutocompleteMultiSelectContext.isOpen, items = _useAutocompleteMultiSelectContext.items, selectedItem = _useAutocompleteMultiSelectContext.selectedItem, highlightedIndex = _useAutocompleteMultiSelectContext.highlightedIndex, getItemProps = _useAutocompleteMultiSelectContext.getItemProps, getMenuProps = _useAutocompleteMultiSelectContext.getMenuProps;
    var styles = (0, _react1.useStyleConfig)("AutocompleteMultiSelect");
    var itemStyles = styles.item;
    var active = itemStyles.active, highlighted = itemStyles.highlighted, restItemStyles = _object_without_properties(itemStyles, [
        "active",
        "highlighted"
    ]);
    var noResults = noResultsContent !== null && noResultsContent !== void 0 ? noResultsContent : _react.default.createElement(_typography.Text, styles.noResults, "No results");
    return _react.default.createElement(_Box.Box, _object_spread({
        as: "ul",
        visibility: isOpen ? "visible" : "hidden"
    }, styles.list, getMenuProps(), rest), isOpen && items.length ? items.map(function(item, index) {
        return _react.default.createElement(_Box.Box, _object_spread({
            as: "li",
            key: "list-item-".concat(index)
        }, restItemStyles, item === selectedItem && active, highlightedIndex === index && highlighted, getItemProps({
            index: index,
            item: item
        })), renderItem(item));
    }) : noResults);
};
var _default = AutocompleteMultiSelectList;
